import MAvatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React, { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { MCNote } from '../../utils/types';

interface ShowLastNoteIconProps {
    record: string | null;
    tag: string;
}

const useStyles = makeStyles((theme) => ({
    small: {
        width: 16,
        height: 16,
        flexShrink: 0,
    },
    center: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
}));

const DEFAULT_COLOR = '#808080';

const makeColorUseStyles = (color: string) =>
    makeStyles((theme) => ({
        color: {
            color: theme.palette.getContrastText(color),
            backgroundColor: color,
        },
    }));

const ShowLastNoteIcon = (props: ShowLastNoteIconProps) => {
    const t = useTranslate();
    const [color, setColor] = useState(DEFAULT_COLOR);
    const [level, setLevel] = useState<string | undefined>();

    useEffect(() => {
        const jsonData: MCNote = props.record ? JSON.parse(props.record) : null;
        const color = jsonData ? jsonData.customFields.thresholdColor : DEFAULT_COLOR;

        setColor(color || DEFAULT_COLOR);
        // threshold.level.2 -> 2
        setLevel(jsonData?.customFields.thresholdName?.split('.').pop());
    }, [props.record]);

    const classes = useStyles();
    const colorClasses = makeColorUseStyles(color ? color : DEFAULT_COLOR)();

    // Don't show anything when color is default
    if (color === DEFAULT_COLOR) {
        return null;
    }

    return (
        <MAvatar
            className={`${classes.small} ${colorClasses.color} ${classes.center}`}
            role='img'
            aria-label={level ? t(`app.ancs.level${level}`) : undefined}
        >
            <Typography variant='h1' component='h2' />
        </MAvatar>
    );
};

export default ShowLastNoteIcon;
